import WizardConfigData from "./WizardConfigData";
import GF from "../../../../lib/utils/GF";

class WizardData {

  constructor(mailingListName = '', configuration = null, deliveryDateTime = new Date(), notiz = '', query = null, mailGenerateRoute = '') {
    this.mailingListName = mailingListName;
    this.configuration = new WizardConfigData();
    this.deliveryDateTime = deliveryDateTime;
    this.notiz = notiz;
    this.query = query;
    this.mailGenerateRoute = mailGenerateRoute;
  }

  getMailingListName() {
    return this.mailingListName;
  }

  setMailingListName(value) {
    this.mailingListName = value;
  }

  getMailGenerateRoute() {
    return this.mailGenerateRoute;
  }

  setMailGenerateRoute(value) {
    this.mailGenerateRoute = value;
  }

  getConfiguration() {
    return this.configuration;
  }

  setConfiguration(value) {
    this.configuration = value;
  }

  getDeliveryDateTime() {
    return this.deliveryDateTime;
  }

  setDeliveryDateTime(value) {
    this.deliveryDateTime = GF.stringToDateTime(value);
  }

  getNotiz() {
    return this.notiz;
  }

  setNotiz(value) {
    this.notiz = value;
  }

  getQuery() {
    return this.query;
  }

  setQuery(query) {
    this.query = query;
  }
}

export default WizardData;
